/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CarpsaleHistoryManagementEditOrderUnitRequest = {
    id?: number;
    deliveryType: CarpsaleHistoryManagementEditOrderUnitRequest.deliveryType;
    deliveryPreferredDate?: string | null;
    deliveryPreferredTime?: CarpsaleHistoryManagementEditOrderUnitRequest.deliveryPreferredTime | null;
    shippingNumber?: string | null;
    postage: number;
    isDeleted: boolean;
};

export namespace CarpsaleHistoryManagementEditOrderUnitRequest {

    export enum deliveryType {
        YAMATO = 'yamato',
        OTHER = 'other',
    }

    export enum deliveryPreferredTime {
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
        '_4' = 4,
        '_5' = 5,
        '_6' = 6,
    }


}

